<script lang="ts">
  import * as Popover from '$lib/components/ui/popover';
  import { Input } from '$lib/components/ui/input';
  import { ScrollArea } from '$lib/components/ui/scroll-area';
  import Button from '@/lib/components/ui/button/button.svelte';
  import { searchRankingActivities } from '@/Util/api';
  import { debouncer } from '@/Util/utils';
  import type { RankingActivityOption } from './rankingsTypes';

  export let selected: RankingActivityOption | null = null;
  export let onSelect: (activity: RankingActivityOption) => void;

  let open = false;
  let hasSearchedOnce = false;
  let query = '';
  let results: RankingActivityOption[] = [];
  let loading = false;
  const searchDebouncer = debouncer(300);

  async function runSearch() {
    loading = true;
    try {
      results = await searchRankingActivities(query);
    } finally {
      loading = false;
    }
  }

  $: if (open && !hasSearchedOnce) {
    hasSearchedOnce = true;
    runSearch();
  }

  function pick(activity: RankingActivityOption) {
    onSelect(activity);
    open = false;
  }
</script>

<Popover.Root portal="#shadcn-ui-dialog-target" bind:open>
  <Popover.Trigger asChild let:builder>
    <Button builders={[builder]} variant="outline" size="sm" class="justify-between font-normal gap-2">
      <span class="truncate max-w-[10rem]">{selected ? selected.name : 'Choose an activity…'}</span>
      <i class="fa-regular fa-chevron-down text-xs opacity-60 shrink-0" />
    </Button>
  </Popover.Trigger>
  <Popover.Content class="w-72 p-2" align="start">
    <Input
      placeholder="Search activities…"
      bind:value={query}
      on:input={() => searchDebouncer.debounce(runSearch)}
    />
    <ScrollArea class="mt-2 h-64">
      {#if loading}
        <div class="py-6 text-center text-sm text-muted-foreground">Searching…</div>
      {:else if results.length === 0}
        <div class="py-6 text-center text-sm text-muted-foreground">No activities found.</div>
      {:else}
        <div class="flex flex-col gap-0.5">
          {#each results as activity (activity.path)}
            <button
              type="button"
              class="flex flex-col items-start rounded-md px-2 py-1.5 text-left hover:bg-muted"
              on:click={() => pick(activity)}
            >
              <span class="w-full truncate text-sm font-medium">{activity.name}</span>
              <span class="text-xs text-muted-foreground">{activity.start_date}</span>
            </button>
          {/each}
        </div>
      {/if}
    </ScrollArea>
  </Popover.Content>
</Popover.Root>
